<div class="spinner">
   <div
      class="spinner-border"
      role="status">
      <span class="sr-only">Loading...</span>
   </div>
</div>
